export default "https://cdn-static.gokick.com/assets/e732fce3df71ad981aa0ee65436659b369042414/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";